import type { FaireProductEntity } from "../../entity_types/product";

export const p_smqdjwvvpa: FaireProductEntity = {
  token: "p_smqdjwvvpa",
  type: "product",
  name: "*NEW* Holiday Safety Matches - 60 Count, Christmas Decor",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/dbaa9c78c0ee08d338c618ee72dbbd8039e5eab598485305ac431cf608ace9c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/152315f7ba22695b1e1f2484674f94836f7aa6ca89e21b0ec1e2c2b48f27692c.jpeg",
    "https://cdn.faire.com/fastly/7e3f3b26dbb880f552e0afed4b12abfe1afef030bb6f8703a2d40b371ed8d325.jpeg",
    "https://cdn.faire.com/fastly/477bc09675685e7196a5226e021dff6d35c6fc965b91f1ab74e68e0ebee8dca7.jpeg",
    "https://cdn.faire.com/fastly/b84ee41fe953d4e627277361b8c7261be4ac4fedc1e641988745cf4bc0aa4de3.png",
  ],
  priceDollars: 7.5,
  description:
    "Add a festive finishing touch to your seasonal assortment with our Holiday Safety Matches. Featuring red, green, and white match tips and a classic plaid label, this decorative accessory brings cheerful holiday charm to candle displays, gift sets, and seasonal home décor collections.\n\nBoth functional and stylish, these safety matches are designed to be displayed on coffee tables, shelves, countertops, or mantels while remaining within easy reach for lighting candles. Easy to merchandise and gift, they pair beautifully with our non-toxic Christmas candles and candle care accessories for a cohesive holiday offering.\n\nDETAILS:\n\n• Color: Red, Green, White Tip \n• 3.75” Matchsticks \n• Approximately 60 Matches Per Jar \n• Safety Matches \n• Strike Match on Strike Pad on Jar to Light \n• Holiday Plaid Design \n• Glass Jar Size: 2 x 2 x 5 ⅜” \n• Designed in the USA, Imported \n• Style No. GM033 \n\nCAUTION:\n\n• Handle Matches with Care \n• Close Bottle Before Striking the Match \n• Keep Out of Reach of Children \n• Keep Away from Hot Surfaces and Flames \n\nCATEGORIES:\nChristmas 2026, Safety matches, Candle matches, Christmas Decor, Holiday decor, Gifts, gifting",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:16.813Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
